import React from "react";
import aboimg from "../Utils/about-img.png";
import "./About.css";

const About = () => {
  return (
    <section className="about-section">
      <div className="container">
        <h2 className="about-title">
          About <span>Us</span>
        </h2>

        <div className="about-content">
          {/* Text Section - Left Side */}
          <div className="about-text">
            <p>
              At <strong>SPI Academy</strong>, we specialize in providing
              comprehensive and practical trading training for individuals
              aspiring to excel in the financial markets. Whether you are a
              beginner or a seasoned trader, our expert-designed programs equip
              you with the knowledge, strategies, and tools needed to navigate
              the complexities of stock, forex, and commodity trading.
            </p>
            <p>
              With a commitment to <strong>excellence</strong>, we bridge the
              gap between theory and real-world application, empowering our
              students to achieve consistent success in their trading journeys.
            </p>
          </div>

          {/* Image Section - Right Side */}
          <div className="about-image">
            <img src={aboimg} alt="About SPI Academy" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;